import { Placement } from '@floating-ui/react';
import { EntityOrThemeWithListTypes } from '@terminal/components/search-modal/utils';
import { ChatMode } from '@terminal/views/alfred/use-chat-navigation/useChatNavigation';

import { Mention } from './mentions/types';

export type ChatInputConfig = {
  placeholder?: string;
  allowedModes?: ChatMode[];
  mode?: ChatMode;
  persistInputTextOnSubmit?: boolean;
  clearDocumentContextOnSubmit?: boolean;
  disableContextHeader?: boolean;
  enableThemeSearch?: boolean;
  placement?: Placement;
  isCustomizedDisabled?: boolean;
  autoFocus?: boolean;
  alfredEverywhere?: boolean;
  enablePromptRefinement?: boolean;
};

export interface SubmitOptions {
  isPromptRefined?: boolean;
  startNewConversation?: boolean;
  mentions?: Mention[];
}

export type ChatSubmitEvent = {
  preventDefault: () => void;
  stopPropagation: () => void;
};

export const PROGRAMMATIC_SUBMIT_EVENT: ChatSubmitEvent = {
  preventDefault: () => {},
  stopPropagation: () => {},
};

export interface ActionHandlers {
  onSubmit: (
    e: ChatSubmitEvent,
    inputValue: string,
    clear: () => void,
    options?: SubmitOptions
  ) => void;
  onKeyDown?: (
    e: React.KeyboardEvent<HTMLElement>,
    inputValue: string,
    clear: () => void
  ) => void;
  onAbort?: () => void;
  onReset?: () => void;
  onSelect: (item: EntityOrThemeWithListTypes, clear: () => void) => void;
}
